import React from "react";

const Faq = () => {
  return (
    <div className="mt-5">
      <div>
        <h1 className="text-center text-3xl font-semibold">FAQ</h1>
        <h1 className="text-center text-2xl font-semibold italic">
          Frequently{" "}
          <span className="underline decoration-red-500 underline-offset-4">
            Asked
          </span>{" "}
          Questions
        </h1>
      </div>
      <div class="collapse">
        <input type="checkbox" />
        <div class="collapse-title text-xl font-medium">
          <h2 id="accordion-collapse-heading-1">
            <button
              type="button"
              class="flex items-center justify-between w-full p-5 font-medium text-left  border border-b-0 border-red-500 rounded-sm "
              data-accordion-target="#accordion-collapse-body-1"
              aria-expanded="true"
              aria-controls="accordion-collapse-body-1"
            >
              <span>What is Warehouse?</span>
              <svg
                data-accordion-icon
                class="w-6 h-6 rotate-180 shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </h2>
        </div>
        <div class="collapse-content">
          <div class="p-5 ">
            <p class="mb-2 ">
              Warehousing is the process of storing physical inventory for sale
              or distribution. Warehouses are used by all different types of
              businesses that need to temporarily store products in bulk before
              either shipping them to other locations or individually to end
              consumers.
            </p>
          </div>
        </div>
      </div>
      <div class="collapse">
        <input type="checkbox" />
        <div class="collapse-title text-xl font-medium">
          <h2 id="accordion-collapse-heading-1">
            <button
              type="button"
              class="flex items-center justify-between w-full p-5 font-medium text-left  border border-b-0 border-red-500 rounded-sm "
              data-accordion-target="#accordion-collapse-body-1"
              aria-expanded="true"
              aria-controls="accordion-collapse-body-1"
            >
              <span>Who needs a warehouse?</span>
              <svg
                data-accordion-icon
                class="w-6 h-6 rotate-180 shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </h2>
        </div>
        <div class="collapse-content">
          <div class="p-5 ">
            <p class="mb-2 ">
              If your business has a retail or eCommerce component, you can
              probably benefit from both warehousing and fulfillment services.
              Your retail space is limited. But as orders grow you'll need space
              for product overflow so you can keep your merchandise flowing.
            </p>
          </div>
        </div>
      </div>

      <div class="collapse">
        <input type="checkbox" />
        <div class="collapse-title text-xl font-medium">
          <h2 id="accordion-collapse-heading-1">
            <button
              type="button"
              class="flex items-center justify-between w-full p-5 font-medium text-left  border border-b-0 border-red-500 rounded-sm "
              data-accordion-target="#accordion-collapse-body-1"
              aria-expanded="true"
              aria-controls="accordion-collapse-body-1"
            >
              <span>What is the role of warehouse?</span>
              <svg
                data-accordion-icon
                class="w-6 h-6 rotate-180 shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </h2>
        </div>
        <div class="collapse-content">
          <div class="p-5 ">
            <p class="mb-2 ">
              Warehousing and the storage of goods play a vital role in the
              logistics supply chain across the world. Not only do warehouses
              provide safe and secure storage around the clock, they also allow
              you to have your goods stored in one central place, which makes
              planning and organising your logistics that much easier.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
